import React from "react";

import { useNavigate } from "react-router-dom";

function ErrorPage() {
  let navigate = useNavigate();
  return (
    <>
      <div
        className="alert alert-secondary"
        role="alert"
        style={{ borderRadius: "0" }}
      >
        <span style={{ cursor: "pointer" }} onClick={() => navigate("/")}>
          Aquta.io - Data Sciences (M) Sdn. Bhd.
        </span>
      </div>
      <div className="container" style={{ textAlign: "center" }}>
        <h3>Page Not Found.</h3>
      </div>
    </>
  );
}

export default ErrorPage;
